import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

export const useSecurity = () => {
    const page = usePage();

    const csrfToken = computed(() => page.props.csrfToken);

    function updateMetaCsrfToken() {
        document
            .querySelector('meta[name="csrf-token"]')
            .setAttribute('content', csrfToken.value);
    }

    return {
        csrfToken,
        updateMetaCsrfToken,
    };
};
